import { ArrowDownwardTwoTone, ArrowUpwardTwoTone } from "@mui/icons-material";
import { Collapse, Tooltip } from "@mui/material";
import { selectToken, selectUser } from "../../../features/auth/authSlice";
import {
  useCreateReferralSourceMutation,
  useDeleteReferralSourceMutation,
  useUpdateReferralSourceMutation,
} from "../../../features/referral-source/referralSourceApiSlice";
import {
  useDeleteCommunityMutation,
  useUpdateCommunityMutation,
} from "../../../features/community/communityApiSlice";

import SwapVertIcon from "@mui/icons-material/SwapVert";
import axios from "axios";
import classNames from "classnames";
import React from "react";
import { FileUploader } from "react-drag-drop-files";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Icons } from "../../../assets";
import IconComponent from "../../../components/DataTable/Icon";
import FilterSelect from "../../../components/Filter/FilterSelect";
import Loading from "../../../components/Loading";
import Pagination from "../../../components/Pagination/Pagination";
import Search from "../../../components/Search/SearchNew";
import { useLSStore } from "../../../context/ls-store";
import { useFetchReferralSourcesMutation } from "../../../features/organisation/organisationApiSlice";
import useDebounce from "../../../hooks/useDebounce";
import ReferralSourceAddModal from "./components/ReferralSourceAddModal";
import ReferralSourceDeleteModal from "./components/ReferralSourceDeleteModal";
import ReferralSourceZoneEditModal from "./components/ReferralSourceZoneEditModal";
import CommunityAddModal from "../Community/components/CommunityAddModal";

const fileTypes = ["csv", "xls", "xlsx"];

const ReferralSourcesList = () => {
  const [referralSources, setReferralSources] = React.useState([]);

  const [searchFilter, setSearchFilter] = React.useState("");

  const [sortNOPOrder, setSortNOPOrder] = React.useState("none");
  const [sortNameOrder, setSortNameOrder] = React.useState("none");
  const [ReferralSourceModalOpen, setReferralSourceModalOpen] =
    React.useState(false);
  const [edit, setEdit] = React.useState(false);
  const [del, setDel] = React.useState(false);
  const [data, setData] = React.useState({});
  const [openDropdown, setOpenDropdown] = React.useState(false);
  const [count, setCount] = React.useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false);

  const [zonesModalOpen, setZonesModalOpen] = React.useState(false);
  const [referralSourceZonesData, setReferralSourceZonesData] =
    React.useState(null);
  const [zoneFilter, setZoneFilter] = React.useState([]);
  const [zones, setZones] = React.useState([]);

  const search = useDebounce(searchFilter, 500);

  const user = useSelector(selectUser);
  const [fetchReferralSources, { isLoading: getLoading }] =
    useFetchReferralSourcesMutation();
  const [createReferralSource, { isLoading: createLoading }] =
    useCreateReferralSourceMutation();
  const [updateReferralSource, { isLoading: updateLoading }] =
    useUpdateReferralSourceMutation();
  const [deleteReferralSource, { isLoading: deleteLoading }] =
    useDeleteReferralSourceMutation();
  const [updateCommunity, { isLoading: updateCommunityLoading }] =
    useUpdateCommunityMutation();
  const [deleteCommunity, { isLoading: deleteCommunityLoading }] =
    useDeleteCommunityMutation();

  const isLoading =
    getLoading ||
    createLoading ||
    updateLoading ||
    updateCommunityLoading ||
    deleteLoading ||
    deleteCommunityLoading;

  const getReferralSources = async ({ limit, skip }) => {
    try {
      const { data, count } = await fetchReferralSources({
        orgId: user.organisation.id,
        limit,
        skip,
        search,
        zones: JSON.stringify(zoneFilter || []),
      }).unwrap();

      setReferralSources(data);
      setCount(count);
    } catch (error) {
      console.error(error.data.message);
    }
  };

  const handleSortNOP = (a, b) => {
    if (sortNOPOrder === "none") {
      return 0;
    } else if (sortNOPOrder === "asc") {
      return a.noOfPatients - b.noOfPatients;
    } else {
      return b.noOfPatients - a.noOfPatients;
    }
  };

  const handleSortName = (a, b) => {
    if (sortNameOrder === "none") {
      return 0;
    } else if (sortNameOrder === "asc") {
      return a.name.localeCompare(b.name);
    } else {
      return b.name.localeCompare(a.name);
    }
  };

  React.useEffect(() => {
    getReferralSources({ limit: 20, skip: 0 });
  }, [search, zoneFilter]);

  const Avatar = ({ name, image }) => {
    return (
      <>
        {image !== null ? (
          <div className="flex items-center gap-2">
            <img
              src={image}
              alt={name}
              className="object-cover w-10 h-10 rounded-full"
            />
          </div>
        ) : (
          <p className="flex items-center justify-center w-10 h-10 m-0 text-white rounded-full bg-primaryblue">
            {name
              ?.split(" ")
              ?.map((n) => n[0])
              ?.slice(0, 2)
              ?.map((n) => n?.toUpperCase())
              ?.join("")}
          </p>
        )}
      </>
    );
  };

  const updateReferralSourceZones = (referralSourceId, zones) => {
    setReferralSources((prev) => {
      const updatedReferralSources = prev.map((referralSource) =>
        referralSource.id === referralSourceId
          ? { ...referralSource, zones }
          : referralSource
      );
      return updatedReferralSources;
    });

    const referralSourceData = referralSources.find(
      (e) => e.id === referralSourceId
    );
    if (referralSourceData?.ref_type === "referralSource") {
      onUpdateReferralSourceZones({ ...referralSourceData, zones });
    }
  };

  const setAlert = useLSStore((state) => state.setAlert);

  const token = useSelector(selectToken);

  const saveReferralSource = async () => {
    try {
      await createReferralSource({
        name: data.name,
        type: data.type,
        contact_name: data.contact_name,
        contact_phone: data.contact_phone,
        contact_email: data.contact_email,
      }).unwrap();

      getReferralSources({ limit: 20, skip: 0 });
    } catch (error) {
      throw new Error(error?.data?.message || error.message);
    }
  };

  React.useEffect(() => {
    setZones(
      Array.from(
        new Set(
          referralSources
            .map((referralSource) =>
              referralSource.zones.map((zone) => zone.name)
            )
            .flat()
            .filter(Boolean)
        )
      ).filter(Boolean)
    );
  }, [referralSources]);

  const handleZoneFilter = (zone) => {
    if (zoneFilter.indexOf(zone) === -1) {
      setZoneFilter([...zoneFilter, zone]);
    } else {
      setZoneFilter(zoneFilter.filter((filter) => filter !== zone));
    }
  };

  const onUpdateReferralSource = async () => {
    try {
      if (data?.ref_type === "community") {
        await updateCommunity({
          id: edit,
          ...data,
        }).unwrap();
      } else {
        await updateReferralSource({
          id: edit,
          ...data,
        }).unwrap();
      }

      if (data?.ref_type === "community" && !data.is_referral) {
        setReferralSources((prev) => {
          const update = [...prev].filter((x) => x.id !== edit);
          return [...update];
        });
      } else {
        setReferralSources((prev) => {
          const update = [...prev];
          const index = update.findIndex((x) => x.id === edit);
          update[index] = data;
          return [...update];
        });
      }
    } catch (error) {
      throw new Error(error?.data?.message || error.message);
    }
  };

  const onUpdateReferralSourceZones = async (referralSourceData) => {
    try {
      await updateReferralSource({
        ...referralSourceData,
      }).unwrap();

      setReferralSources((prev) => {
        const update = [...prev];
        const index = update.findIndex((x) => x.id === edit);
        update[index] = data;
        return [...update];
      });
    } catch (error) {
      throw new Error(error?.data?.message || error.message);
    }
  };

  const onDeleteReferralSource = async () => {
    try {
      if (data.ref_type === "referralSource") {
        await deleteReferralSource({
          id: del,
        }).unwrap();
      } else {
        await deleteCommunity({
          id: del,
        }).unwrap();
      }

      setReferralSources((prev) => {
        const update = [...prev].filter((x) => x.id !== del);
        return [...update];
      });
    } catch (error) {
      setAlert({
        message: error?.data?.message || error.message,
        severity: "error",
      });
    }
  };

  const onEdit = (referralSource) => {
    const [street, city, state, zip] = referralSource.address.split(", ");
    setData({ ...referralSource, street, city, state, zip, is_referral: true });
    setEdit(referralSource.id);
    setReferralSourceModalOpen(true);
    setDeleteModalOpen(false);
  };

  const onDelete = (referralSource) => {
    setDeleteModalOpen(true);
    setData(referralSource);
    setDel(referralSource.id);
  };

  const handleSelectReferralSource = (referralSource) => {
    setZonesModalOpen(true);
    setReferralSourceZonesData(referralSource);
  };

  const clearInput = () => {
    setData({});
  };

  const downloadCSV = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/referralSource/get/template`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "referralSource-template.csv");
    document.body.appendChild(link);
    link.click();
  };

  return (
    <div className="flex flex-col items-start py-4 overflow-hidden max-h-[calc(100vh-100px)]">
      <Loading loading={isLoading} />
      <div className="flex flex-row items-center justify-between w-full px-16">
        <div className="flex flex-row items-center w-full gap-12">
          <h1 className="m-0 text-2xl font-bold w-fit whitespace-nowrap">
            Referral Sources{" "}
            <span className="ml-2 text-base font-bold text-primaryblue">
              {count}
            </span>
          </h1>
          <div className="flex flex-row items-center w-full gap-8 max-w-7xl">
            <Search value={searchFilter} setValue={setSearchFilter} />
            <FilterSelect
              value={zoneFilter}
              handleChange={handleZoneFilter}
              data={zones}
              placeholder="Filter by Zone ..."
            />
          </div>
        </div>
        <button
          onClick={() => {
            setReferralSourceModalOpen(true);
            setEdit(false);
          }}
          className="flex items-center justify-center px-4 py-2 text-sm font-bold text-white rounded-lg bg-primaryblue whitespace-nowrap"
        >
          Add Referral Source
        </button>
      </div>

      <div className="w-full px-16 mt-2">
        <Pagination count={count} api={getReferralSources} />
        <div className="relative w-full  mb-2 overflow-x-auto overflow-y-auto bg-white rounded-lg shadow  max-h-[calc(100vh-300px)]">
          <table className="relative w-full whitespace-no-wrap bg-white border-collapse table-auto table-striped">
            <thead>
              <tr className="h-16 text-base font-bold text-left text-white bg-primaryblue whitespace-nowrap">
                <th className="px-4 py-3">
                  <div className="flex flex-row items-center gap-2">
                    <p className="m-0">Name</p>
                    <button
                      className="flex flex-col items-center gap-1"
                      onClick={() => {
                        if (sortNameOrder === "none") {
                          setSortNameOrder("asc");
                        }
                        if (sortNameOrder === "asc") {
                          setSortNameOrder("desc");
                        }
                        if (sortNameOrder === "desc") {
                          setSortNameOrder("none");
                        }
                      }}
                    >
                      {sortNameOrder === "asc" ? (
                        <Tooltip title="Sort Descending">
                          <ArrowDownwardTwoTone />
                        </Tooltip>
                      ) : sortNameOrder === "desc" ? (
                        <Tooltip title="Sort Ascending">
                          <ArrowUpwardTwoTone />
                        </Tooltip>
                      ) : (
                        // <div className="flex items-center h-4">
                        //   <div className="w-6 h-[2px] bg-white" />
                        // </div>
                        <div className="flex items-center providerlist-icon">
                          <SwapVertIcon />
                        </div>
                      )}
                    </button>
                  </div>
                </th>
                {/* <th className="px-4 py-3">Address</th> */}
                {process.env.REACT_APP_ENV === "dev" && (
                  <th className="px-4 py-3">Zones</th>
                )}
                <th className="px-4 py-3">
                  <div className="flex flex-row items-center gap-2">
                    <p className="m-0">No of Patients</p>
                    <button
                      className="flex flex-col items-center gap-1"
                      onClick={() => {
                        if (sortNOPOrder === "none") {
                          setSortNOPOrder("asc");
                        }
                        if (sortNOPOrder === "asc") {
                          setSortNOPOrder("desc");
                        }
                        if (sortNOPOrder === "desc") {
                          setSortNOPOrder("none");
                        }
                      }}
                    >
                      {sortNOPOrder === "asc" ? (
                        <Tooltip title="Sort Descending">
                          <ArrowDownwardTwoTone />
                        </Tooltip>
                      ) : sortNOPOrder === "desc" ? (
                        <Tooltip title="Sort Ascending">
                          <ArrowUpwardTwoTone />
                        </Tooltip>
                      ) : (
                        // <div className="flex items-center h-4">
                        //   <div className="w-6 h-[2px] bg-white" />
                        // </div>
                        <div className="flex items-center providerlist-icon">
                          <SwapVertIcon />
                        </div>
                      )}
                    </button>
                  </div>
                </th>
                <th className="px-4 py-3">
                  <p className="m-0">Edit</p>
                </th>
                <th className="px-4 py-3">
                  <p className="m-0">Delete</p>
                </th>
              </tr>
            </thead>
            <tbody>
              {referralSources.length === 0 ? (
                <tr>
                  <td
                    colSpan={process.env.REACT_APP_ENV === "dev" ? 10 : 9}
                    className="py-6 text-lg text-center text-gray-400"
                  >
                    No records found
                  </td>
                </tr>
              ) : (
                referralSources
                  .filter(Boolean)
                  // .filter((referralSource) =>
                  //   referralSource.name
                  //     .toLowerCase()
                  //     .includes(searchFilter.toLowerCase())
                  // )
                  .sort((a, b) => handleSortNOP(a, b))
                  .sort((a, b) => handleSortName(a, b))
                  .map((referralSource, index) => (
                    <tr
                      className={classNames(
                        "text-left text-gray-900 h-24 whitespace-nowrap",
                        index !== referralSources.length - 1
                          ? "border-b"
                          : "border-none"
                      )}
                      key={index}
                    >
                      <td className="px-4 py-3 text-left">
                        <p className="m-0 font-semibold underline">
                          {referralSource.name}
                        </p>
                      </td>
                      {/* <td className="px-4 py-3 text-left text-gray-700">
                      {referralSource.address}
                    </td> */}
                      {process.env.REACT_APP_ENV === "dev" && (
                        <td className="gap-2 px-4 py-3 text-left text-gray-700">
                          {referralSource.zones.length > 0
                            ? referralSource.zones
                                .map((zone) => zone.name)
                                .join(", ")
                            : "NA"}
                          {/* <button className="pt-2 ml-2">
                            <IconComponent
                              tooltip="Edit Zone"
                              icon={"Edit_Icon"}
                              i={referralSource}
                              onClick={() => {
                                handleSelectReferralSource(referralSource);
                              }}
                            />
                          </button> */}
                        </td>
                      )}
                      <td className="px-4 py-3 text-left text-gray-700">
                        {referralSource.noOfPatients}
                      </td>
                      <td className="px-4 py-3 text-left text-gray-700">
                        <IconComponent
                          tooltip="Edit Referral Source"
                          icon={"Edit_Icon"}
                          i={referralSource}
                          onClick={() => onEdit(referralSource)}
                        />
                      </td>
                      <td className="px-4 py-3 text-left text-gray-700">
                        <IconComponent
                          tooltip="Delete Referral Source"
                          icon={"Delete_Icon"}
                          i={referralSource}
                          onClick={() => onDelete(referralSource)}
                        />
                      </td>
                    </tr>
                  ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {ReferralSourceModalOpen && data?.ref_type !== "community" && (
        <ReferralSourceAddModal
          isOpen={ReferralSourceModalOpen}
          edit={edit}
          clearInput={clearInput}
          onUpdate={onUpdateReferralSource}
          onSave={saveReferralSource}
          setOpen={setReferralSourceModalOpen}
          data={data}
          setData={setData}
        />
      )}
      {ReferralSourceModalOpen && data?.ref_type === "community" && (
        <CommunityAddModal
          isOpen={ReferralSourceModalOpen}
          edit={edit}
          clearInput={clearInput}
          onUpdate={onUpdateReferralSource}
          onSave={saveReferralSource}
          setOpen={setReferralSourceModalOpen}
          data={data}
          setData={setData}
        />
      )}
      {deleteModalOpen && (
        <ReferralSourceDeleteModal
          isOpen={deleteModalOpen}
          clearInput={clearInput}
          onDeleteReferralSource={onDeleteReferralSource}
          setOpen={setDeleteModalOpen}
          data={data}
        />
      )}
      {zonesModalOpen && (
        <ReferralSourceZoneEditModal
          open={zonesModalOpen}
          referralSource={referralSourceZonesData}
          setOpen={setZonesModalOpen}
          updateReferralSourceZones={updateReferralSourceZones}
        />
      )}
    </div>
  );
};

export default ReferralSourcesList;
